import { useEffect, useState } from 'react';
import { otpStatus } from 'services/api-otp';
import { useGetProfileQuery } from 'store/slices/profile-api';

export const useOtpEnabled = () => {
  const { data: userProfileResponse } = useGetProfileQuery();
  const twoFactorServices = userProfileResponse?.twoFactorServices;

  return twoFactorServices ? twoFactorServices.includes('SMS') : false;
};

const decodeJwt = (token: string) => {
  return JSON.parse(atob(token.split('.')[1]));
};

const useOtpStatus = () => {
  const [status, setStatus] = useState<string[]>(['']);

  useEffect(() => {
    const getStatus = async () => {
      const response: string[] = await otpStatus();
      if (response) setStatus(response);
    };
    getStatus();
  }, []);
  if (status?.includes('TOTP')) return 'TOTP';
  if (status?.includes('SMS')) return 'SMS';
  if (status?.includes('EMAIL')) return 'EMAIL';
  return '';
};

export default useOtpStatus;
